import React from 'react'
import { connect } from 'react-redux'
import { useStaticQuery, graphql } from 'gatsby'

import { TwitterX } from '~/icons/Twitter'
import { Linkedin } from '~/icons/Linkedin'
import { Youtube } from '~/icons/Youtube'
import { Facebook } from '~/icons/Facebook'

const NavSocials = ({ lang }) => {
  let globalSettings = null

  const datas = useStaticQuery(graphql`
    query {
      globalSettings: allContentfulGlobalSettings {
        nodes {
          title
          facebook
          footerPhoneNumber
          footerPhoneNumber2
          footerPhoneNumberLabel
          footerPhoneNumberLabel2
          headerPhoneNumber
          headerPhoneNumberLabel
          node_locale
          linkedin
          twitter
          youtube
        }
      }
    }
  `)

  datas.globalSettings?.nodes?.forEach((item) => {
    if (item.node_locale === lang && item.title !== 'dummy content') {
      globalSettings = item
    }
  })

  return (
    <ul className="panel-nav__socials mobile-subnav-hidden">
      {globalSettings?.twitter && (
        <li>
          <a
            className="panel-nav__social"
            href={globalSettings?.twitter}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="sr-only">Compte Twitter</span>

            <TwitterX className="icon-white w-8" />
          </a>
        </li>
      )}

      {globalSettings?.facebook && (
        <li>
          <a
            className="panel-nav__social"
            href={globalSettings?.facebook}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="sr-only">Compte Facebook</span>

            <Facebook className="icon-white" width="24" height="24" />
          </a>
        </li>
      )}

      {globalSettings?.linkedin && (
        <li>
          <a
            className="panel-nav__social"
            href={globalSettings?.linkedin}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="sr-only">Compte Linkedin</span>

            <Linkedin className="icon-white" width="24" height="24" />
          </a>
        </li>
      )}

      {globalSettings?.youtube && (
        <li>
          <a
            className="panel-nav__social"
            href={globalSettings?.youtube}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="sr-only">Compte Youtube</span>
            <Youtube className="icon-white" width="24" height="24" />
          </a>
        </li>
      )}
    </ul>
  )
}

const mapStateToProps = ({ lang }) => {
  return { lang }
}

export default connect(mapStateToProps, null)(NavSocials)
